import React from 'react';
export function Footer() {
  return <footer className="bg-slate-950 text-slate-500 py-8 md:py-12 px-4 text-center text-xs relative overflow-hidden" data-id="element-145">
      <div className="absolute top-0 left-0 w-full h-1 bg-gradient-to-r from-kid-purple via-kid-pink to-kid-sky" data-id="element-146"></div>
      <div className="max-w-4xl mx-auto relative z-10" data-id="element-147">
        <p className="mb-4 md:mb-6" data-id="element-148">
          © {new Date().getFullYear()} Sistema de Lectura en Orden Correcto™.
          Todos los derechos reservados.
        </p>
        <div className="flex flex-wrap justify-center gap-4 md:gap-6 mb-4 md:mb-8" data-id="element-149">
          <a href="#" className="hover:text-kid-purple transition-colors" data-id="element-150">
            Términos y Condiciones
          </a>
          <a href="#" className="hover:text-kid-pink transition-colors" data-id="element-151">
            Política de Privacidad
          </a>
          <a href="#" className="hover:text-kid-sky transition-colors" data-id="element-152">
            Contacto
          </a>
        </div>
        <p className="text-[10px] opacity-60 max-w-2xl mx-auto leading-relaxed" data-id="element-153">
          Este sitio no es parte del sitio web de Facebook o Facebook Inc.
          Además, este sitio NO está respaldado por Facebook de ninguna manera.
          FACEBOOK es una marca registrada de FACEBOOK, Inc.
        </p>
      </div>
    </footer>;
}